import RuleCycle from './src/main';

/* istanbul ignore next */
RuleCycle.install = function(Vue) {
  Vue.component(RuleCycle.name, RuleCycle);
};

export default RuleCycle;
